
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"plus-square (2)","transform":"translate(-2 -2)","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('rect',{attrs:{"data-name":"Rectangle 4242","width":"14","height":"14","rx":"2","transform":"translate(3 3)"}}),_c('path',{attrs:{"data-name":"Line 1107","d":"M7 10h6"}})])])
          )
        }
      }
    